import type { Transaction } from '@/lib/transactions/types';

/**
 * The invoice-detail endpoint is the authority for which rows belong to the selected invoice.
 * In particular, an open invoice can legitimately contain a projected installment dated later in
 * the cycle. Filtering those rows against the browser's current day makes the drawer disagree with
 * both the invoice total and transaction count.
 */
export function visibleFaturaTransactions(
  transactions: Transaction[],
): Transaction[] {
  return transactions;
}
